import { authenticatedApiFetch, authenticatedStudentApiFetch } from '../utils/utils'


export const allFilesForClassService = async (classId, parentFolder = '') => {
    if (!classId) {
        return []
    }
    const res = await authenticatedApiFetch(`/files/?classes=${classId}&parent_folder_id=${parentFolder}`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => {
            console.error(error)
            return []
        })
    return Array.isArray(res) ? res : (res?.results ?? [])
}

export const allSharedFilesService = async (page = 1, limit = 10, filters = {}) => {
    const offset = (page - 1) * limit
    const params = new URLSearchParams({
        limit: limit.toString(),
        offset: offset.toString()
    })

    if (filters.subject) params.append('subject', filters.subject)
    if (filters.level) params.append('level', filters.level)
    if (filters.chapter) params.append('chapter', filters.chapter)
    if (filters.search) params.append('search', filters.search)
    if (filters.filter) params.append('filter', filters.filter)

    const res = await authenticatedApiFetch(`/shared-files/?${params.toString()}`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => console.error(error))
    return res
}

export const sharedFilesByIdService = async (id, page = 1, limit = 10, parentFolderId = null, filters = {}, idParamName = 'teacher_id') => {
    const offset = (page - 1) * limit
    const params = new URLSearchParams({
        [idParamName]: id?.toString() || '',
        limit: limit.toString(),
        offset: offset.toString()
    })

    // Ajouter le paramètre parent_folder_id pour filtrer par dossier
    if (parentFolderId !== null && parentFolderId !== undefined && parentFolderId !== '') {
        params.append('parent_folder_id', parentFolderId.toString())
    } else {
        // Si on est à la racine, demander explicitement les fichiers sans parent
        params.append('parent_folder_id', 'null')
    }

    if (filters.subject) params.append('subject', filters.subject)
    if (filters.level) params.append('level', filters.level)
    if (filters.chapter) params.append('chapter', filters.chapter)
    if (filters.search) params.append('search', filters.search)
    if (filters.filter) params.append('filter', filters.filter)

    const res = await authenticatedApiFetch(`/shared-files?${params.toString()}`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => console.error(error))
    return res
}

// Récupère les dossiers partagés par un enseignant (pagination similaire aux fichiers)
export const sharedFoldersByIdService = async (id, page = 1, limit = 10, parentFolderId = null, filters = {}, idParamName = 'teacher_id') => {
    const offset = (page - 1) * limit
    const params = new URLSearchParams({
        [idParamName]: id?.toString() || '',
        limit: limit.toString(),
        offset: offset.toString()
    })

    // Ajouter le paramètre parent_folder_id pour filtrer par dossier
    if (parentFolderId !== null && parentFolderId !== undefined && parentFolderId !== '') {
        params.append('parent_folder_id', parentFolderId.toString())
    } else {
        // Si on est à la racine, demander explicitement les dossiers sans parent
        params.append('parent_folder_id', 'null')
    }

    if (filters.subject) params.append('subject', filters.subject)
    if (filters.level) params.append('level', filters.level)
    if (filters.chapter) params.append('chapter', filters.chapter)
    if (filters.search) params.append('search', filters.search)
    if (filters.filter) params.append('filter', filters.filter)

    const res = await authenticatedApiFetch(`/shared-folders?${params.toString()}`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => console.error(error))
    return res
}

export const sharedFilesForClassService = async (classId) => {
    if (!classId) {
        return []
    }
    const res = await authenticatedApiFetch(`/class-shared-files/?classes=${classId}`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => {
            console.error(error)
            return []
        })
    return Array.isArray(res) ? res : (res?.results ?? [])
}

export const sharedFilesForStudentService = async () => {
    const res = await authenticatedStudentApiFetch(`/student-files/`, { method: 'GET' })
        .then(res => res.json())
        .catch(error => console.error(error))
    return res
}

export const createFileService = async (data) => {
    const res = await authenticatedApiFetch('/files/', {
        method: 'POST',
        body: data,
        headers: {}
    })
        .catch(error => console.error(error))
    return res
}


export const deleteFileService = async (id) => {
    const res = await authenticatedApiFetch(`/files/${id}/`, { method: 'DELETE' })
        .catch(error => console.error(error))
    return res
}

export const updateFileService = async (id, data) => {
    const res = await authenticatedApiFetch(`/files/${id}/`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    })
        .catch(error => { throw error })
    return res
}
